import { Divider } from "@material-ui/core";
import { Container, Grid } from "@mui/material";
import axios from "axios";
import {
  AttachmentFilesCard,
  AutoCompleteComponent,
  ColorPickerInput,
  FormCard,
  FormLabel,
  FormUploadImage,
  ImportDocumentModal,
  ModalError,
  ModalSuccess,
  NumberInput,
  Page,
  PrimaryButton,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  SwitchInput,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

const FormParameterDsp = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const pageTitle = `${id ? "Edit" : "Add"} DSP`;

  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [optionCountry, setOptionCountry] = useState([]);
  const [optionCurrency, setOptionCurrency] = useState([]);
  const [payload, setPayload] = useState({
    name: "",
    person_name: "",
    color: "#000000",
    link: "",
    person_phone: "",
    person_email: "",
    image_logo: "",
    is_pay_service: false,
    address: "",
    process_method: "integration",
    country_id: "",
    dsp_currency_id: "",
    domicile: "domestic",
  });
  const [dspLogo, setDspLogo] = useState({
    image_url: null,
    image: null,
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [listDspTemplate, setListDspTemplate] = useState([]);

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleCloseModal = () => setModalVisible(false);

  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/dsp/${id}`, { headers });
      const { data } = res?.data;
      const requiredKeys = [
        "name",
        "person_name",
        "color",
        "link",
        "person_phone",
        "person_email",
        "is_pay_service",
        "address",
        "process_method",
        "country_id",
        "dsp_currency_id",
      ];
      const filteredData = requiredKeys?.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      setPayload({
        image_logo: data?.profile_image,
        domicile: data?.domicile || "domestic",
        ...filteredData,
      });
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const getDspTemplate = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/dsp/detail`, {
        headers,
        params: { dsp_id: id },
      });
      const modifiedData = res?.data?.data?.url_detail?.map(item => ({
        ...item,
        name: item?.url?.substring(item?.url.lastIndexOf("/") + 1),
      }));
      setListDspTemplate(modifiedData);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const getOptionCountry = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/country/table?page=1&per_page=100`,
        { headers }
      );
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.country_name,
      }));
      setOptionCountry(modifiedData);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const getOptionCurrency = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/currency/datatable?page=1&per_page=100`,
        { headers }
      );
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        label: item?.currency_iso_code,
      }));
      setOptionCurrency(modifiedData);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getOptionCountry(), getOptionCurrency()];
    if (id) {
      promises.push(getDetail());
      promises.push(getDspTemplate());
    }

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = id ? axios.put : axios.post;
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    if (dspLogo?.image) {
      formData.append("image_logo", dspLogo?.image || "");
    }
    try {
      setLoadingPage(true);
      await method(`${hardBaseUrl}/dsp${id ? `/${id}` : ""}`, formData, {
        headers,
      });
      ModalSuccess(`Succesfully ${id ? "update" : "save"} dsp`).then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleUploadFile = async files => {
    const formData = new FormData();
    formData.append("dsp_id", id);
    files?.forEach(item => {
      formData.append("files", item);
    });
    try {
      setLoadingButton(true);
      await axios.post(`${hardBaseUrl}/upload-dsrf/example/create`, formData, {
        headers,
      });
      ModalSuccess("Successfully upload documents").then(() => history.go(0));
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      handleCloseModal();
      setLoadingButton(false);
    }
  };
  const handleDeleteFile = async fileId => {
    try {
      await axios.delete(`${hardBaseUrl}/upload-dsrf/delete/${fileId}`, {
        headers,
      });
      ModalSuccess("Successfully delete data").then(() => history.go(0));
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Page className={classes.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData({ pageTitle })}
            backButton
          />
          <Divider className={classes?.divider} />
          <Grid container columnSpacing={3}>
            <Grid item xs={12} md={6}>
              <SectionLabel title="DSP Information" />
              <FormCard>
                <Grid container direction="column" rowSpacing={2}>
                  {MockFieldFormDspInformation({
                    optionCountry,
                    optionCurrency,
                  }).map(({ key, options, title, type }) => (
                    <Grid item key={key}>
                      <FormLabel label={title} required />
                      {type === "autocomplete" ? (
                        <AutoCompleteComponent
                          placeholder={title}
                          options={options}
                          value={
                            options?.find(
                              option => option?.id === Number(payload?.[key])
                            ) || null
                          }
                          onChange={e => handleChangePayload(e, key)}
                          size="small"
                          width="100%"
                        />
                      ) : type === "upload_image" ? (
                        <FormUploadImage
                          imageUrl={dspLogo.image_url || payload?.image_logo}
                          setImageLogo={setDspLogo}
                          noLabel
                        />
                      ) : type === "color_picker" ? (
                        <ColorPickerInput
                          value={payload?.color}
                          onChange={color =>
                            handleChangePayload(color, "color")
                          }
                        />
                      ) : type === "select" ? (
                        <SelectInput
                          options={options}
                          optionKey="id"
                          optionLabel="name"
                          value={payload?.[key] || ""}
                          onChange={e =>
                            handleChangePayload(e?.target?.value, key)
                          }
                          width="100%"
                        />
                      ) : (
                        <TextInput
                          placeholder={title}
                          value={payload?.[key]}
                          onChange={e =>
                            handleChangePayload(e?.target?.value, key)
                          }
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </FormCard>
            </Grid>
            <Grid item xs={12} md={6}>
              <SectionLabel title="Person In Charge" />
              <FormCard>
                <Grid container direction="column" rowSpacing={2}>
                  {MockFieldFormPIC.map(
                    ({ key, title, type, multiline, rows }) => (
                      <Grid item key={key}>
                        {title && <FormLabel label={title} required />}
                        {type === "switch" ? (
                          <SwitchInput
                            label="DSP pay for service"
                            checked={payload?.is_pay_service}
                            onChange={e =>
                              handleChangePayload(
                                e?.target?.checked,
                                "is_pay_service"
                              )
                            }
                          />
                        ) : type === "number" ? (
                          <NumberInput
                            placeholder={title}
                            autoComplete={`new-${key}`}
                            value={payload?.[key]}
                            onChange={e => handleChangePayload(e, key)}
                          />
                        ) : (
                          <TextInput
                            placeholder={title}
                            value={payload?.[key]}
                            onChange={e =>
                              handleChangePayload(e?.target?.value, key)
                            }
                            multiline={multiline}
                            rows={rows}
                          />
                        )}
                      </Grid>
                    )
                  )}
                </Grid>
              </FormCard>
              <SectionLabel title="DSP Template" />
              <FormCard>
                <Grid container direction="column" rowSpacing={2} mb="16px">
                  {listDspTemplate?.map((item, index) => (
                    <Grid item key={index}>
                      <AttachmentFilesCard
                        fileName={item?.name}
                        filePath={item?.url}
                        handleRemove={() => handleDeleteFile(item?.id)}
                      />
                    </Grid>
                  ))}
                </Grid>
                <PrimaryButton
                  label="Upload Template"
                  onClick={() => setModalVisible(true)}
                />
              </FormCard>
            </Grid>
          </Grid>
          <Grid container justifyContent="right">
            <PrimaryButton label="Save" onClick={handleSubmit} />
          </Grid>
        </Container>
      )}
      <ImportDocumentModal
        open={modalVisible}
        onClose={handleCloseModal}
        modalTitle="Upload Data"
        preload={listDspTemplate}
        multiple
        maxWidth="sm"
        maxTruncate={45}
        loadingButton={loadingButton}
        onSubmit={handleUploadFile}
      />
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Parameter",
    link: "/admin/parameter/dsp-admin",
  },
  {
    label: "DSP",
    link: "/admin/parameter/dsp-admin",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const optionProcessMethod = [
  {
    id: "integration",
    name: "Integration",
  },
  {
    id: "upload",
    name: "Upload",
  },
];
const optionsDomicile = [
  {
    id: "domestic",
    name: "Domestic",
  },
  {
    id: "overseas",
    name: "Overseas",
  },
];
const MockFieldFormDspInformation = ({ optionCountry, optionCurrency }) => [
  {
    title: "DSP Name",
    key: "name",
  },
  { title: "DSP Logo", type: "upload_image" },
  { title: "Identity Color", type: "color_picker" },
  {
    title: "URL Endpoint",
    key: "link",
  },
  {
    title: "Process Method Flag",
    key: "process_method",
    options: optionProcessMethod,
    type: "select",
  },
  {
    title: "Country",
    key: "country_id",
    options: optionCountry,
    type: "autocomplete",
  },
  {
    title: "Currency",
    key: "dsp_currency_id",
    options: optionCurrency,
    type: "autocomplete",
  },
  {
    title: "Domicile",
    key: "domicile",
    options: optionsDomicile,
    type: "select",
  },
];
const MockFieldFormPIC = [
  {
    title: "The name of the person in charge",
    key: "person_name",
  },
  {
    title: "Email",
    key: "person_email",
  },
  {
    title: "Phone Number",
    key: "person_phone",
    type: "number",
  },
  {
    title: "Address",
    key: "address",
    multiline: true,
    rows: 4,
  },
  { type: "switch" },
];
export default FormParameterDsp;
